document.addEventListener("DOMContentLoaded", function () {
  // Configure/customize these variables.
  var showChar = 400; // How many characters are shown by default
  var ellipsestext = "...";
  var moretext = "Show more";
  var lesstext = "Show less";

  var paragraphs = document.querySelectorAll(".des-text");

  paragraphs.forEach(function (paragraph) {
    var content = paragraph.innerHTML;

    if (content.length > showChar) {
      var c = content.substr(0, showChar);
      console.log(c);
      var h = content.substr(showChar, content.length - showChar);
      console.log(h);

      var html =
        c +
        '<div class="moreellipses">' +
        ellipsestext +
        '&nbsp;</div><div class="morecontent"><div>' +
        h +
        '</div><a href="" class="morelink">' +
        moretext +
        "</a></div>";

      paragraph.innerHTML = html;
    }
  });

  var moreLinks = document.querySelectorAll(".morelink");
  moreLinks.forEach(function (moreLink) {
    moreLink.addEventListener("click", function (event) {
      event.preventDefault();

      var link = event.target;
      var moreContent = link.previousElementSibling;
      console.log(moreContent);
      var ellipses = link.parentElement.previousElementSibling;
      console.log(ellipses);

      if (link.classList.contains("less")) {
        link.classList.remove("less");
        link.innerHTML = moretext;
      } else {
        link.classList.add("less");
        link.innerHTML = lesstext;
      }

      if (moreContent.classList.contains("more-txt")) {
        moreContent.classList.remove("more-txt");
      } else {
        moreContent.classList.add("more-txt");
      }

      ellipses.style.display =
        ellipses.style.display === "none" ? "inline" : "none";
    });
  });
});
